import { render } from "./tep-address-nsi-button.vue?vue&type=template&id=3450964a&scoped=true"
import script from "./tep-address-nsi-button.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-address-nsi-button.vue?vue&type=script&setup=true&lang=js"

import "./tep-address-nsi-button.vue?vue&type=style&index=0&id=3450964a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3450964a"],['__file',"src/views/tep/tep-grid/components/tep-address-nsi-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3450964a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3450964a', __exports__)) {
    api.reload('3450964a', __exports__)
  }
  
  module.hot.accept("./tep-address-nsi-button.vue?vue&type=template&id=3450964a&scoped=true", () => {
    api.rerender('3450964a', render)
  })

}


export default __exports__